import jwtDecode from "jwt-decode";

export const getLoggedInUserEmail = () => {
  const token = localStorage.getItem("token");
  if (!token) return null;

  try {
    const decoded = jwtDecode(token);
    return decoded.email || null;
  } catch (error) {
    return null;
  }
};
